































































































































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
@Component({
  components: { SideBar }
})
export default class Legal extends Vue {
  onHere(){
    const routeData = this.$router.resolve({ path: '/privacy/PersonalData'})
    window.open(routeData.href, '_blank')
  }
}
